<template>
  <div class="content-video">
    <figure v-if="data.videoEmbedded?.provider === 'vimeo'" class="video-figure vimeo" :class="[`-${data.display}`]">
      <iframe
        v-if="data.videoEmbedded.providerUid"
        :src="`https://player.vimeo.com/video/${data.videoEmbedded.providerUid}`"
        allowfullscreen
      >
      </iframe>
      <figcaption v-if="data.videoCaption" class="caption copy-small">{{ data.videoCaption }}</figcaption>
    </figure>

    <figure
      v-else-if="data.videoEmbedded?.provider === 'youtube'"
      class="video-figure youtube"
      :class="[`-${data.display}`]"
    >
      <iframe
        v-if="data.videoEmbedded.providerUid"
        :src="`https://www.youtube.com/embed/${data.videoEmbedded.providerUid}`"
        allowfullscreen
      >
      </iframe>
      <figcaption v-if="data.videoCaption" class="caption copy-small">{{ data.videoCaption }}</figcaption>
    </figure>

    <figure
      v-else-if="data.videoInline && data.videoInline.video?.mp4Url"
      class="video-figure video"
      :class="[`-${data.display}`]"
    >
      <video
        class="inline-video"
        :poster="data.posterImage?.responsiveImage?.src"
        :controls="data.showControls"
        :autoplay="data.autoplay"
        :loop="data.loop"
        muted
        playsinline
        :aria-label="data.videoInline.video.alt as string"
      >
        <source :src="data.videoInline.video.mp4Url" type="video/mp4" />
        Sorry, it appears your system does not support video playback.
      </video>
      <figcaption v-if="data.videoCaption" class="caption copy-small">{{ data.videoCaption }}</figcaption>
    </figure>
  </div>
</template>

<script setup lang="ts">
import type { ContentVideoFragment } from '#gql';

defineProps<{
  data: ContentVideoFragment;
}>();
</script>

<style scoped lang="scss">
.content-video {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
    padding-top: var(--spacing-2xs);
    padding-bottom: var(--spacing-2xs);
  }

  .video-figure {
    width: 100%;
    grid-column: 1 / -1;

    &.-big {
      @media (--md), (--lg) {
        grid-column: 3 / 23;
      }
    }

    &.-small {
      @media (--md), (--lg) {
        grid-column: 5 / 21;
      }
    }

    > iframe,
    > .inline-video {
      width: 100%;
      aspect-ratio: 16 / 9;
      object-fit: cover;
      margin-bottom: var(--spacing-4xs);
      border: 0;
    }
  }
}
</style>
